import { CoreEvent, eventNames } from '@carvana/core-events';
import { useCallback, useContext } from 'react';
import UserContext, { useIsLoggedIn } from '~/context/common/UserContext';
import { useOpenAccountModal } from '~/hooks/common/accountModal/useAccountModal';

function openManageSavedSearched() {
  CoreEvent.emit(eventNames.favorites.mfe.drawer.open, {
    tab: 'searches'
  });
}

export default function useLogInAndManageSavedSearches() {
  const { triggerFetchUserProfile } = useContext(UserContext);
  const openAccountModal = useOpenAccountModal();
  const isLoggedIn = useIsLoggedIn();

  const onSuccess = useCallback(() => {
    triggerFetchUserProfile();
    openManageSavedSearched();
  }, [triggerFetchUserProfile]);

  return useCallback(() => {
    if (isLoggedIn) {
      openManageSavedSearched();

      return;
    }

    openAccountModal({
      callerIdentifier: 'SearchAlert',
      displayTitle: 'MANAGE SAVED SEARCHES',
      onSuccess
    });
  }, [isLoggedIn, onSuccess, openAccountModal]);
}
